import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgAddCircleIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    width="1em"
    height="1em"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M32 2a30 30 0 1 0 30 30A30.026 30.026 0 0 0 32 2Zm18 33a.945.945 0 0 1-1 1H36v13a.945.945 0 0 1-1 1h-6a.945.945 0 0 1-1-1V36H15a.945.945 0 0 1-1-1v-6a.945.945 0 0 1 1-1h13V15a.945.945 0 0 1 1-1h6a.945.945 0 0 1 1 1v13h13a.945.945 0 0 1 1 1Z"
      className="add_circle_svg__nc-icon-wrapper"
    />
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgAddCircleStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgAddCircleIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const AddCircleIcon: any = SvgAddCircleStyle;
export default AddCircleIcon;
